import { useState } from "react";
import "../../style/createproduct.css";
import { IoArrowBackOutline } from "react-icons/io5";
import { useForm } from "react-hook-form";
import { useMutation, useQuery } from "@apollo/client";
import {
  CREATE_PRODUCT,
  DELETE_CATEGORY,
  DELETE_SUBCATEGORY,
  UPLOAD_FILES_MUTATION,
} from "../../graphql/mutation/productMutations";
import { Toaster, toast } from "react-hot-toast";
import ImageUploadField from "../../components/image-upload-field";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDropdown from "../../components/dropdown";
import LoadingButton from "../../modules/icons/loading-button";
import {
  CREATE_CATEGORY,
  CREATE_SUBCATEGORY,
} from "../../graphql/mutation/productMutations";
import CustomDeleteDropdown from "../../components/delete-dropdown";
import axios from "axios";
import {
  GET_CATEGORIES_WITHOUT_SUB,
  GET_SUBCATEGORIES,
} from "../../graphql/queries/productQueries";

const CreateProduct = () => {
  const location = useLocation();
  const { register, handleSubmit, reset } = useForm();
  const [uploadFileMutation] = useMutation(UPLOAD_FILES_MUTATION);
  const [uploadLoadingImage,setUploadLoadingImage] = useState(false);
  const {
    register: registerCategory,
    handleSubmit: handleSubmitCategory,
    reset: resetCategory,
  } = useForm(); // Category form
  const {
    register: registerSubcategory,
    handleSubmit: handleSubmitSubcategory,
    reset: resetSubcategory,
  } = useForm(); // Subcategory form

  const uploadToDigitalOcean = async (images) => {
    const formData = new FormData();
    images.forEach((file) => {
      formData.append("images", file);
    });

    try {
      const response = await axios.post(
        "http://localhost:3001/fileupload",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        console.log("Images uploaded successfully:", response.data);
        return response.data;
      } else {
        console.error(
          "Failed to upload images:",
          response.status,
          response.data
        );
        return null;
      }
    } catch (error) {
      console.error(
        "Error uploading images:",
        error.response ? error.response.data : error.message
      );
      return null;
    }
  };

  const ConvertToBase64 = (file) => {
    return new Promise((resolve,reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
    })
  }

  const [deleteCategory, { loading: deleteCategoryLoading }] =
    useMutation(DELETE_CATEGORY);
  const [deleteSubCategory, { loading: deleteSubcategoryLoading }] =
    useMutation(DELETE_SUBCATEGORY);

  const handleDeleteCategory = async (id) => {
    try {
      await deleteCategory({ variables: { id } });
    } catch (error) {
      console.error("Failed to delete category", error);
    }
  };

  const handleDeleteSubCategory = async (id) => {
    try {
      await deleteSubCategory({ variables: { id } });
    } catch (error) {
      console.error("Failed to delete subcategory", error);
    }
  };

  const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);

  const [subImageOne, setSubImageOne] = useState(null);
  const [subImageOneUrl, setSubImageOneUrl] = useState(null);

  const [subImageTwo, setSubImageTwo] = useState(null);
  const [subImageTwoUrl, setSubImageTwoUrl] = useState(null);

  const [subImageThree, setSubImageThree] = useState(null);
  const [subImageThreeUrl, setSubImageThreeUrl] = useState(null);

  const [openForm, setOpenForm] = useState(false);

  const {
    data: getCategory,
    loading,
    refetch: refetchGetCategory,
  } = useQuery(GET_CATEGORIES_WITHOUT_SUB, {});
  const { data: getSubcategory, refetch: refetchGetSubCategory } = useQuery(
    GET_SUBCATEGORIES,
    {}
  );

  const [
    createCategory,
    {
      error: createcategoryError,
      loading: createCategoryLoading,
      refetch: refetchCategory,
    },
  ] = useMutation(CREATE_CATEGORY, {
    onCompleted: () => {
      refetchGetCategory();
    },
  });

  const [
    createSubCategory,
    {
      error: createSubcategoryError,
      loading: createSubcategoryLoading,
      refetch: refeSubCategory,
    },
  ] = useMutation(CREATE_SUBCATEGORY, {
    onCompleted: () => {
      refetchGetSubCategory();
    },
  });

  const handleCreateCategory = handleSubmitCategory(async (credentials) => {
    try {
      const category_name = credentials.category_name.toLowerCase();
      const { data } = await createCategory({
        variables: { category_name },
      });

      if (data?.insert_category_one) {
        toast("Category created successfully");
        resetCategory();
      } else {
        toast("Failed to create category");
      }
    } catch (error) {
      toast("Error creating category");
      console.log(createcategoryError);
      console.error(error);
    }
  });

  const handleCreateSubCategory = handleSubmitSubcategory(
    async (credentials) => {
      try {
        if (!category) {
          toast("Please select a category first");
          return;
        }
        const subcategory_name = credentials.subcategory_name.toLowerCase();
        const { data } = await createSubCategory({
          variables: {
            subcategory_name: subcategory_name,
            category_id: category,
          },
        });

        if (data?.insert_subcategory_one) {
          toast("Subcategory created successfully");
          //  setSubCategory(data.insert_subcategory_one.id); // Set the created subcategory ID
          resetSubcategory();
        } else {
          toast("Failed to create subcategory");
        }
      } catch (error) {
        toast("Error creating subcategory");
        console.log(createSubcategoryError);
        console.error(error);
      }
    }
  );

  const [generatePresignedUrl, { loading:uploadLoading, error, data }] = useMutation(UPLOAD_FILES_MUTATION);

  const requestPresignedUrls = async (images) => {
    try {
      const presignedUrls = await Promise.all(
        images.map(async (file) => {
          const response = await generatePresignedUrl({
            variables: {
              fileName: file.name,
              fileType: file.type,
            },
          });

          return response.data.generatePresignedUrl;
        })
      );

      return presignedUrls;
    } catch (err) {
      console.error('Error requesting presigned URLs:', err);
      return null;
    }
  };

  const uploadFileToPresignedUrl = async (file, presignedUrl) => {
    try {
      await fetch(presignedUrl, {
        method: "PUT",
        headers: {
          "Content-Type": file.type,
          "x-amz-acl": "public-read",
        },
        body: file,
      });
      return true;
    } catch (error) {
      console.error("Failed to upload file to presigned URL:", error);
      return false;
    }
  };

  const UploadToDigitalOcean = async (images) => {
    try {
      setUploadLoadingImage(true)
      const presignedUrls = await requestPresignedUrls(images);
  
      const uploadResults = await Promise.all(
        images.map((file, index) => 
          uploadFileToPresignedUrl(file, presignedUrls[index].presignedUrl)
        )
      );
  
      // 3. Check if all uploads were successful
      if (uploadResults.every((result) => result)) {
        console.log("Images uploaded successfully");
        setUploadLoadingImage(false)
        return presignedUrls.map((urlData) => urlData.publicUrl);
        
      } else {
        console.error("Some files failed to upload.");
        return null;
      }
    } catch (error) {
      console.error("Error uploading images:", error);
      return null;
    }
  };
  

  const [createProduct, { loading: createLoading }] =
    useMutation(CREATE_PRODUCT);
  const [category, setCategory] = useState();
  const [subCategory, setSubCategory] = useState();
  const navigate = useNavigate();

  const resetFormFields = () => {
    // Reset form inputs
    reset();

    // Reset image states
    setImage(null);
    setImageUrl(null);
    setSubImageOne(null);
    setSubImageOneUrl(null);
    setSubImageTwo(null);
    setSubImageTwoUrl(null);
    setSubImageThree(null);
    setSubImageThreeUrl(null);

    // Reset dropdown states
    setCategory(null);
    setSubCategory(null);
  };

  const handleImageChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setImage(e.target.files[0]);
      setImageUrl(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleSubImageOneChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSubImageOne(e.target.files[0]);
      setSubImageOneUrl(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleSubImageTwoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSubImageTwo(e.target.files[0]);
      setSubImageTwoUrl(URL.createObjectURL(e.target.files[0]));
    }
  };

  const handleSubImageThreeChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setSubImageThree(e.target.files[0]);
      setSubImageThreeUrl(URL.createObjectURL(e.target.files[0]));
    }
  };

  const sanitizeFileName = (fileName) => {
    return fileName.replace(/[^a-z0-9.]/gi, "_").toLowerCase();
  };

  const handleCreate = handleSubmit(async (credential) => {
    try {
      const images = [image, subImageOne, subImageTwo, subImageThree].filter(
        Boolean
      );
      if (images.length < 4) {
        toast("Please upload all images");
        return;
      }

      if (!category) {
        toast("Please choose a category");
        return;
      }

      const uploadResult = await UploadToDigitalOcean(images);
      if (!uploadResult) {
        toast("Failed to upload images");
        return;
      }

      const [mainImageUrl, subImageOneUrl, subImageTwoUrl, subImageThreeUrl] = uploadResult;

      // await createProduct({
      //   variables: {
      //     name: credential.name,
      //     model: credential.model,
      //     price: parseInt(credential.price),
      //     category_id: category,
      //     subcategory_id: subCategory,
      //     image_url: `https://axra.sgp1.digitaloceanspaces.com/bonchon-erp/alpha-website/${sanitizeFileName(
      //       image.name
      //     )}`,
      //     product_specification: credential.specification,
      //     product_description: credential.description,
      //     sub_img_one_url: `https://axra.sgp1.digitaloceanspaces.com/bonchon-erp/alpha-website/${sanitizeFileName(
      //       subImageOne.name
      //     )}`,
      //     sub_img_two_url: `https://axra.sgp1.digitaloceanspaces.com/bonchon-erp/alpha-website/${sanitizeFileName(
      //       subImageTwo.name
      //     )}`,
      //     sub_img_three_url: `https://axra.sgp1.digitaloceanspaces.com/bonchon-erp/alpha-website/${sanitizeFileName(
      //       subImageThree.name
      //     )}`,
      //   },
      // });

        await createProduct({
        variables: {
          name: credential.name,
          model: credential.model,
          price: parseInt(credential.price),
          category_id: category,
          subcategory_id: subCategory,
          image_url: mainImageUrl,
          product_specification: credential.specification,
          product_description: credential.description,
          sub_img_one_url: subImageOneUrl,
          sub_img_two_url: subImageTwoUrl,
          sub_img_three_url: subImageThreeUrl,
        },
      });

      toast("Product created successfully");
      resetFormFields();
    } catch (err) {
      toast("Product creation failed");
      console.error("Error creating product:", err);
    }
  });

  return (
    <>
      <Toaster />
      <div className="create-product-container">
        <div className="create-product-layout">
          <div className="create-form-heading">
            <div className="create-form-heading-layout">
              <div className="back-button-container">
                <button
                  onClick={() =>
                    navigate("/dashboard", { state: { refetch: true } })
                  }
                >
                  <IoArrowBackOutline size={24} />
                  <p>Back</p>
                </button>
              </div>
              <h2>Create New Product</h2>
            </div>
          </div>
          <div className="product-form-container">
            <div
              className={`create-category-form-container ${
                openForm ? "openCategoryForm" : ""
              }`}
            >
              <div className="create-category-form-layout">
                <div className="create-category-form-layout-category-from">
                  <form
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "start",
                      paddingLeft: "0rem",
                      paddingTop: "1rem",
                    }}
                    className="category-form"
                    action=""
                    onSubmit={() => handleCreateCategory()}
                  >
                    <div style={{ width: "80%" }} className="input-field">
                      <label htmlFor="">Category</label>
                      <input
                        //  style={{width:''}}
                        name="category_name"
                        type="text"
                        placeholder="Enter category name"
                        {...registerCategory("category_name", {
                          required: "category_name is required",
                        })}
                      />
                    </div>
                    <button
                      type="submit"
                      style={{
                        marginLeft: "0",
                        background:
                          "linear-gradient(to right, #11343b, #625aa7, #271f57)",
                        borderRadius: "0.25rem",
                        color: "white",
                        width: "80%",
                      }}
                    >
                      {createCategoryLoading ? <LoadingButton /> : "Add"}
                    </button>
                  </form>
                  <div style={{ paddingTop: "1rem" }}>
                    <CustomDeleteDropdown
                      label="Choose to edit category"
                      isMain={true}
                      onChangeCategory={getCategory}
                      //setCategory={setCategory}
                      // setSubCategory={setSubCategory}
                      //addable={false}
                      setOpenForm={setOpenForm}
                      detailPath="categorydetail"
                      // categories={categories}
                      deleteLoading={deleteCategoryLoading}
                      onDeleteCategory={handleDeleteCategory}
                    />
                  </div>
                </div>

                <div className="create-category-form-layout-subcategory-from">
                  <form
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "start",
                      paddingLeft: "0rem",
                      paddingTop: "1rem",
                    }}
                    className="subcategory-form"
                    action=""
                    onSubmit={handleCreateSubCategory}
                  >
                    <div style={{ width: "80%" }}>
                      <CustomDropdown
                        label="Select Related Category"
                        isMain={true}
                        setCategory={setCategory}
                        setSubCategory={setSubCategory}
                        addable={false}
                        setOpenForm={setOpenForm}
                      />
                    </div>

                    <div style={{ width: "80%" }} className="input-field">
                      <label htmlFor="">Subcategory</label>
                      <input
                        //style={{ width: "100%" }}
                        name="subcategory_name"
                        type="text"
                        placeholder="Enter subcategory name"
                        {...registerSubcategory("subcategory_name", {
                          required: "subcategory_name is required",
                        })}
                      />
                    </div>
                    <button
                      type="submit"
                      style={{
                        marginLeft: "0",
                        background:
                          "linear-gradient(to right, #11343b, #625aa7, #271f57)",
                        borderRadius: "0.25rem",
                        color: "white",
                        width: "80%",
                      }}
                    >
                      {createSubcategoryLoading ? (
                        <LoadingButton />
                      ) : (
                        "Add new Subcategory"
                      )}
                    </button>
                  </form>
                  <div style={{ paddingTop: "1rem" }}>
                    <CustomDeleteDropdown
                      label="Choose to edit subcategory"
                      isMain={false}
                      //setCategory={setCategory}
                      // setSubCategory={setSubCategory}
                      //addable={false}
                      detailPath="subcategorydetail"
                      setOpenForm={setOpenForm}
                      onChangeSubCategory={getSubcategory}
                      // categories={categories}
                      deleteLoading={deleteSubcategoryLoading}
                      onDeleteSubCategory={handleDeleteSubCategory}
                    />
                  </div>
                </div>
              </div>
              <button className="" onClick={() => setOpenForm(false)}>
                X
              </button>
            </div>
            <form action="" onSubmit={handleCreate}>
              <div className="create-product-form-layout">
                <div className="create-product-form">
                  <div className="input-field">
                    <label htmlFor="">Product Name</label>
                    <input
                      name="name"
                      type="text"
                      placeholder="Enter product name"
                      {...register("name", {
                        required: "name is required",
                      })}
                    />
                  </div>
                  <CustomDropdown
                    label="Select Category"
                    isMain={true}
                    setCategory={setCategory}
                    setSubCategory={setSubCategory}
                    addable={true}
                    setOpenForm={setOpenForm}
                  />

                  <div className="input-field">
                    <label htmlFor="">Price</label>
                    <input
                      name="price"
                      type="number"
                      placeholder="Enter price"
                      {...register("price", {
                        required: "price is required",
                      })}
                    />
                  </div>

                  <div className="input-field">
                    <label htmlFor="">Model</label>
                    <input
                      name="model"
                      type="text"
                      placeholder="Enter model"
                      {...register("model", {
                        required: "model is required",
                      })}
                    />
                  </div>
                </div>
                <div className="form-divider"></div>
                <div className="create-product-form">
                  <CustomDropdown
                    label="Select Subcategory"
                    isMain={false}
                    setCategory={setCategory}
                    setSubCategory={setSubCategory}
                    addable={true}
                    setOpenForm={setOpenForm}
                  />
                  <div className="input-field">
                    <label htmlFor="">Product Description</label>
                    <textarea
                      name="description"
                      type="text"
                      placeholder="Enter Product Description"
                      {...register("description", {
                        required: "description is required",
                      })}
                    />
                  </div>
                  <div className="input-field">
                    <label htmlFor="">Product Specification</label>
                    <textarea
                      name="specification"
                      type="text"
                      placeholder="Enter Product Specification"
                      {...register("specification", {
                        required: "dspecification is required",
                      })}
                    />
                  </div>
                </div>
                <div className="form-divider"></div>
                <div className="create-product-form-img-upload">
                  <div className="img-btn-container">
                    <div className="image-upload-field-container">
                      <ImageUploadField
                        handleImageChange={handleImageChange}
                        image={image}
                        imageUrl={imageUrl}
                        label="Main Image"
                        size={40}
                      />
                    </div>
                  </div>
                  <div className="sub-image-upload-container">
                    <div className="sub-image-upload-container-layout">
                      <ImageUploadField
                        handleImageChange={handleSubImageOneChange}
                        image={subImageOne}
                        imageUrl={subImageOneUrl}
                        label="Side Image"
                        fontsize="10px"
                        size={25}
                      />
                    </div>
                    <div className="sub-image-upload-container-layout">
                      <ImageUploadField
                        handleImageChange={handleSubImageTwoChange}
                        image={subImageTwo}
                        imageUrl={subImageTwoUrl}
                        label="Side Image"
                        fontsize="10px"
                        size={25}
                      />
                    </div>
                  </div>

                  <div className="sub-image-upload-container">
                    <div className="sub-image-upload-container-layout">
                      <ImageUploadField
                        handleImageChange={handleSubImageThreeChange}
                        image={subImageThree}
                        imageUrl={subImageThreeUrl}
                        label="Side Image"
                        fontsize="10px"
                        size={25}
                      />
                    </div>
                    <div className="sub-image-upload-container-layout"></div>
                  </div>
                </div>
              </div>
              <div className="submit-button-container">
                <button type="submit">
                  {(createLoading || uploadLoadingImage) ? <LoadingButton /> : "Create"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
export default CreateProduct;
